__turbopack_context__.v({
  "description": "event-promo-card-module-scss-module__aK0CYW__description",
  "figure": "event-promo-card-module-scss-module__aK0CYW__figure",
  "imageWrapper": "event-promo-card-module-scss-module__aK0CYW__imageWrapper",
  "timeAndPlace": "event-promo-card-module-scss-module__aK0CYW__timeAndPlace",
});
